import React from 'react';
import { PanelRightOpen } from 'lucide-react';
import RiskDriverItem, { type RiskDriverItemProps } from './RiskDriverItem';

const MAX_VISIBLE_ITEMS = 5;
const SKELETON_COUNT = 5;

type RiskDriversListProps = {
    title: string;
    items: RiskDriverItemProps[];
    isLoading: boolean;
    onViewAll: () => void;
};

const RiskDriversList = ({ title, items, isLoading, onViewAll }: RiskDriversListProps) => {
    const visibleItems = items.slice(0, MAX_VISIBLE_ITEMS);

    return (
        <div className='bg-white shadow-portfolio-summary-card rounded-lg py-3 flex flex-col gap-2 divide-y h-full'>
            <h4 className='text-primary text-base font-normal tracking-tight leading-snug px-5 '>{title}</h4>

            <div className='flex flex-col px-5 pt-4 gap-4 flex-1'>
                <div className='flex flex-col gap-4'>
                    {isLoading ? (
                        Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                            <div key={i}>
                                <RiskDriverItem name='' score={null} description={null} isLoading />
                            </div>
                        ))
                    ) : visibleItems.length === 0 ? (
                        <p className='text-sm text-grey-80'>No records found</p>
                    ) : (
                        visibleItems.map((item, i) => (
                            <div key={i}>
                                <RiskDriverItem {...item} />
                            </div>
                        ))
                    )}
                </div>
                {items.length > MAX_VISIBLE_ITEMS && (
                    <button
                        className='flex items-center justify-center gap-2 w-full border border-border rounded-lg px-3 py-2 text-sm text-foreground hover:bg-grey-10 transition-colors mt-auto'
                        onClick={onViewAll}
                    >
                        View all Drivers
                        <PanelRightOpen className='h-4 w-4' />
                    </button>
                )}
            </div>
        </div>
    );
};

export default RiskDriversList;
